import { useMemo } from 'react'

import { COUNTRY_CODES } from '../../shared/waitlist.ts'

/** Country names in the visitor's own language, sorted the way they would read them. */
export function useCountryOptions(): { code: string; name: string }[] {
  return useMemo(() => {
    let names: Intl.DisplayNames | null = null
    try {
      names = new Intl.DisplayNames(undefined, { type: 'region' })
    } catch {
      /* very old browser — fall back to the codes themselves */
    }
    return COUNTRY_CODES.map((code) => ({ code, name: names?.of(code) ?? code })).sort((a, b) =>
      a.name.localeCompare(b.name),
    )
  }, [])
}
